<template>
  <div class="app">
	  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
		<van-list v-model="loading"  offset="20" :finished="finished" :finished-text="finishedTxt" @load="onLoad">
			<lyjqCard :list="list"></lyjqCard>
		</van-list>
	  </van-pull-refresh>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import{httpAction,getAction,putAction} from "@/api/manage"
import { Toast,Picker } from 'vant'
import lyjqCard from '../common/lyjq-card'
export default {
	components:{lyjqCard},
	data(){
		return{
			list:[],
			loading: false,
			finished: false,
			refreshing: false,
			pageNo:0,
			finishedTxt:""
		}
	},
	mounted() {
		this.onRefresh()
	},
	methods:{
		init(){
			let openId = this.$store.getters.openId;
      		let params = {pageNo:this.pageNo,openId:openId};
			getAction('/zhshj/hmfwlyjqzs/page',params)
			.then((res)=>{
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
				this.loading = false;
                let data = res.result.records
                data.map((item,index)=>{
                    if(typeof(item.jqtp)=="string"){
                        item.jqtps = item.jqtp.split(",")
                    }
                    if(item.jqtp==null){
                        item.jqtps = [""]
                    }
                })
                this.list = this.list.concat(data)
                if(res.result.pages <= this.pageNo){
					this.finished = true;
					if(this.pageNo!=1){
						this.finishedTxt = "暂无更多了"
					}
                }
			})
		},
		onLoad(){
			this.pageNo++
			this.init();
		},
		onRefresh() {
			// 清空列表数据
			this.finished = false;
			this.finishedTxt = ""
			// 重新加载数据
			// 将 loading 设置为 true，表示处于加载状态
			this.loading = true;
			this.pageNo = 0;
			this.refreshing  = true;
			this.onLoad();
		}
	}
}
</script>

<style scoped lang="less">